import styled from '@emotion/styled'

const FullSizeCenteredContent = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export default FullSizeCenteredContent;
